module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Proof of work equivalent days to rewrite the BCH chain from moment of fork. A 3 day average is used to determine hashrate.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        The ratio of total work since the split divided by estimate of hashrates at that time. The 5%, 10% and 25% are percentages of global hashpower. For example, it will take about " + _vm._s(_vm.replace_chain) + " for hashpower equivalent to that of BTC to rewrite the BCH chain from moment of fork until now. For a miner with 25% hashpower it will take about " + _vm._s(_vm.replace_chain_rate(0.25)) + ".\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-attack"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7556c84","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/rewrite-fork.vue
// module id = 562
// module chunks = 1